import { StyleSheet, ViewProps } from 'react-native'
import { BreadcrumbData } from 'zens-storybook'
import { useSchedule } from 'zens-store'
import { useTranslation } from 'react-i18next'
import { useBreadcrumb } from '@dms/hook'

import { LayoutHeader } from '../layout'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends ViewProps {
  companyId: number
  scheduleId: number
  title?: string
  breadcrumbItems?: BreadcrumbData[]
}

const ScheduleHeader = (props: Props) => {
  const { companyId, scheduleId, title, breadcrumbItems, style, ...otherProps } = props
  const { t } = useTranslation()
  const schedule = useSchedule({ companyId, scheduleId })

  const breadcrumb = useBreadcrumb([
    {
      title: t('Workspaces'),
      href: `/companies/${companyId}/workspaces`,
    },
    {
      title: t('Schedules'),
      href: `/companies/${companyId}/workspaces/schedules`,
    },
    {
      title: schedule.data?.name || '',
    },
    ...(breadcrumbItems || []),
  ])
  return (
    <LayoutHeader
      breadcrumb={breadcrumb}
      title={title || schedule.data?.name || ' '}
      style={[styles.container, style]}
      {...otherProps}
    />
  )
}

export default ScheduleHeader
